import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

const helpMe = [
  {
    name: "👥अध्यक्ष & बचत गट नोंद",
    steps: [
      "अध्यक्षांनी स्वतःसाठी युजरनेम तयार करून लॉगिन करा.",
      "होम स्क्रीनवर ‘नोंदणी’ या बटणावर क्लिक करा ->  योग्य माहिती भरा",
      "नवीन बचत गट तयार करा आणि गटाची माहिती नीट भरा (नाव, बँक, व्याज इ.).",
      "गट सारांश या पृष्ठावर जाऊन ‘नवीन बचत गट तयार करा’ वर क्लिक करा."
    ]
  },
  {
    name: "💰गटाचा हिशोब (पूर्वीच्या महिन्यांचा)",
    steps: [
      "ज्या महिन्यापासून अ‍ॅपमध्ये काम सुरू करायचं, त्या आधीपर्यंतचा हिशोब तयार ठेवा.",
      "प्रत्येक सभासदाची एकूण बचत व बाकी कर्ज, थकीत व्याज व दंड याची माहिती गोळा करा आणि हिशोब तयार करा.",
      "एकूण उत्पन्न = एकूण कर्ज वाटप  + एकूण उपलब्ध रक्कम  - एकूण जमा बचत",
      "हिशोब करण्यासाठी PDF चा वापर करा जेणेकरून हिशोब अचूक होईल आणि गटामध्ये माहिती भरायला सुलभता येईल"
    ]
  },
  {
    name: "💼 गट व्यवहार",
    steps: [
      "हिशोब झाल्यावर जे एकूण उत्पन्न आहे ते इतर उत्पन्न म्हणून नोंदवा.",
      "तारीख तुम्ही हिशोब केलेल्या महिन्याची पैसे भरण्याची अंतिम तारीख जी होती ती वापरा.",
      "गटाचे व्यवहार (बँक चार्जेस, बँक व्य्याज, कमिशन, इतर खर्च , इतर उत्त्पन्न ) हे गट व्यवहार मध्ये भरा.",
      "मेनू → जमा/खर्च नोंदवा → गट व्यवहार → (तारीख , व्यवहार,रक्कम , शेरा अचूक भरा) → सेव्ह करा."

    ]
  },
  {
    name: "👥सभासद नोंद",
    steps: [
      "हिशोब आणि गट तयार झाल्यावर सभासदांची नोंद करूया",
      "मेनू → सभासद → सभासद जोडा वापरा.",
      "सभासद नोंद करताना हिशोब पत्राचा वापर करा आणि सर्व माहिती भरा.",
      "उदा.-  नाव , मोबाईल नंबर, एकूण बचत , बाकी कर्ज , थकीत दंड , थकीत व्याज "
    ]
  },
  {
    name: "📅 मासिक भरणा पत्रक",
    steps: [
      "सर्व सभासद व हिशोब तयार झाल्यावर मासिक भरणा तयार करा.",
      "मेनू → अहवाल (Reports) → मासिक भरणा पत्रक → 'नवीन हप्ता माहिती भरा'",
      "उदा: हप्ता क्रमांक - 94, मासिक बचत - ₹94,000, तारीख - 10 जून 2025",
      "उदा: हप्ता क्रमांक - 95, मासिक बचत - ₹1,000, तारीख - 10 जुलै 2025",
      "सदस्यांच्या व्यवहाराप्रमाणे त्याला व्याज आणि दंड लावावा.",
      "मासिक भरणा पत्रक -> सदस्याचे मागील महिन्याचे व्याज आणि दंड नोंद करा.",
      "आत्तापर्यंतची एकूण बचत ही जून (सुरुवात) महिन्या मध्ये दाखवण्यात आलेली आहे. पुढील हप्ते नियमित असतील."
    ]
  },

  {
    name: "💸 जमा-खर्च नोंदवा",
    steps: [
      "सभासदांचे व्यवहार (मासिक बचत, व्याज, दंड, नवीन कर्ज, कर्ज परतफेड, वार्षिक व्याज वितरण) हे प्रत्येक सभासदाच्या नावाखाली भरा.",
      "मेनू → जमा/खर्च नोंदवा → सभासदाचे नाव → जमा/खर्च नोंद करा → (तारीख , व्यवहार,रक्कम , शेरा अचूक भरा) → सेव्ह करा."
    ]
  },
  {
    name: "📄 अहवाल / Reports",
    steps: [
      "मासिक, सभासद किंवा कालावधी आधारित अहवाल पाहा/शेअर करा.",
      "मेनू → अहवाल (Reports) → मासिक / सभासद / कालावधी अहवाल"
    ]
  }
];

const MobileView = () => {
  const [url] = useState(`https://bachatgat.vakralabs.com/`);

  return (
    <div className="container mt-4">
      <Helmet>
        <title>BG-Mitra - बचत गट मित्र</title>
        <meta name="description" content="BG Mitra helps Self-Help Groups (SHGs) manage savings, loans, and expenses efficiently. Track members, generate reports, and stay organized." />
        <meta property="og:title" content="BG-Mitra - बचत गट मित्र" />
        <meta property="og:description" content="BG Mitra helps Self-Help Groups (SHGs) manage savings, loans, and expenses efficiently. Track members, generate reports, and stay organized." />
      </Helmet>
      <div className="row">
        {/* Left help section */}
        <div className="col-lg-7 col-md-6 mb-4">
          <div className="card shadow-sm h-100" style={{ background: "#f8fafc" }}>
            <div className="card-body">
              <h4 className="mb-3 text-teal">BG Mitra ॲप कसे वापरावे ?</h4>
              <div style={{ maxHeight: 540, overflowY: 'auto', fontSize: '1.05em', textAlign: 'left' }}>
                {helpMe.map((section, idx) => (
                  <div key={idx} className="mb-4">
                    <div className="fw-bold mb-2">{section.name}</div>
                    <ol style={{ paddingLeft: 20 }}>
                      {section.steps.map((step, i) => (
                        <li key={i} style={{ marginBottom: 4, textAlign: 'left' }}>{step}</li>
                      ))}
                    </ol>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* Right mobile view */}
        <div className="col-lg-5 col-md-6 col-sm-12">
          <div className="card shadow-lg">
            <div className="card-body p-0">
              <iframe
                src={url}
                width="100%"
                height="600"
                className="rounded"
                style={{ border: 'none' }}
                title="Mobile Web View"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileView;